(() => {
  function initLuckyFooter(footer) {
    if (!footer || footer.dataset.luckyInitialized === 'true') return;

    footer.dataset.luckyInitialized = 'true';

    const dialog = footer.querySelector('[data-lucky-cookie-dialog]');
    const open = footer.querySelector('[data-lucky-cookie-open]');
    const close = footer.querySelector('[data-lucky-cookie-close]');
    const form = footer.querySelector('[data-lucky-cookie-form]');
    const reject = footer.querySelector('[data-lucky-cookie-reject]');
    const allow = footer.querySelector('[data-lucky-cookie-allow]');
    const status = footer.querySelector('[data-lucky-cookie-status]');

    const preferences = footer.querySelector('[data-consent-preferences]');
    const analytics = footer.querySelector('[data-consent-analytics]');
    const marketing = footer.querySelector('[data-consent-marketing]');
    const doNotSell = footer.querySelector('[data-consent-do-not-sell]');

    function api() {
      return window.Shopify?.customerPrivacy || null;
    }

    function setStatus(message) {
      if (status) status.textContent = message || '';
    }

    function sync() {
      const privacy = api();

      if (!privacy?.currentVisitorConsent) return;

      const consent = privacy.currentVisitorConsent();

      preferences.checked = consent.preferences === 'yes';
      analytics.checked = consent.analytics === 'yes';
      marketing.checked = consent.marketing === 'yes';
      doNotSell.checked = consent.sale_of_data === 'no';
    }

    function openDialog() {
      if (!dialog) return;

      sync();

      if (dialog.showModal) {
        dialog.showModal();
      } else {
        dialog.setAttribute('open', '');
      }
    }

    function closeDialog() {
      if (!dialog) return;

      if (dialog.close) {
        dialog.close();
      } else {
        dialog.removeAttribute('open');
      }
    }

    function save(options) {
      const privacy = api();

      if (!privacy?.setTrackingConsent) {
        setStatus('Privacy controls are temporarily unavailable.');
        return;
      }

      setStatus('Saving your choices…');

      privacy.setTrackingConsent(
        {
          preferences: options.preferences,
          analytics: options.analytics,
          marketing: options.marketing,
          sale_of_data: options.sale_of_data
        },
        () => {
          setStatus('Your privacy choices have been saved.');

          window.setTimeout(closeDialog, 650);
        }
      );
    }

    open?.addEventListener('click', openDialog);
    close?.addEventListener('click', closeDialog);

    dialog?.addEventListener('click', event => {
      if (event.target === dialog) closeDialog();
    });

    form?.addEventListener('submit', event => {
      event.preventDefault();

      save({
        preferences: preferences.checked,
        analytics: analytics.checked,
        marketing: marketing.checked,
        sale_of_data: !doNotSell.checked
      });
    });

    reject?.addEventListener('click', () => {
      preferences.checked = false;
      analytics.checked = false;
      marketing.checked = false;

      save({
        preferences: false,
        analytics: false,
        marketing: false,
        sale_of_data: !doNotSell.checked
      });
    });

    allow?.addEventListener('click', () => {
      preferences.checked = true;
      analytics.checked = true;
      marketing.checked = true;

      save({
        preferences: true,
        analytics: true,
        marketing: true,
        sale_of_data: !doNotSell.checked
      });
    });
  }

  function initAll() {
    document.querySelectorAll('[data-lucky-footer]').forEach(initLuckyFooter);
  }

  document.addEventListener('DOMContentLoaded', initAll);
  document.addEventListener('shopify:section:load', initAll);

  initAll();
})();